import RingPager from '@jetbrains/ring-ui/components/pager/pager'
import * as React from 'react'

import {noop} from '../../../utils/empty'

import styles from './Pager.css'

type DefaultProps = {
  openTotal: boolean
  changeCurrentPage: (arg0: number) => unknown
}
type Props = DefaultProps & {
  currentPage: number
  pageSize: number
  total: number
  show?: boolean
}
export default class Pager extends React.PureComponent<Props> {
  static defaultProps: DefaultProps = {
    changeCurrentPage: noop,
    openTotal: false,
  }

  getTotal(): number {
    const {currentPage, openTotal, pageSize, total} = this.props
    // With openTotal, show last page as ...
    const adjustedTotal = openTotal ? total - pageSize : total
    // Always show requested page
    return Math.max(currentPage * pageSize, adjustedTotal)
  }

  generateHref(page: number): string {
    const params = new URLSearchParams(document.location.search)
    params.set('page', page.toString())
    return `${document.location.pathname}?${params.toString()}`
  }

  render(): React.ReactNode {
    const {currentPage, openTotal, pageSize, show, changeCurrentPage} = this.props
    return show === true ? (
      <RingPager
        total={this.getTotal()}
        currentPage={currentPage}
        pageSize={pageSize}
        visiblePagesLimit={5}
        openTotal={openTotal}
        onPageChange={changeCurrentPage}
        onLoadPage={changeCurrentPage}
        className={styles.pager}
        disablePageSizeSelector
        hrefFunc={this.generateHref}
      />
    ) : null
  }
}
